import { createContext, useEffect, useState } from 'react';
import { Bank, BanksResponse, BankResponse, CountriesResponse, Country } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type BanksContextProps = {
    banks: Bank[];
    countries: Country[];
    totalPage: number;
    loadCountries: (page: number) => Promise<void>;
    loadBanks: (page: number) => Promise<void>;
    addBank: (bank: Bank) => Promise<string>;
    updateBank: (bank: Bank) => Promise<string>;
    deleteBank: (id: number) => Promise<string>;

}



export const BanksContext = createContext({} as BanksContextProps);

export const BanksProvider = ({ children }: any) => {

    const [banks, setBanks] = useState<Bank[]>([]);
    const [countries, setCountries] = useState<Country[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;

    useEffect(() => {
        loadCountries();
    }, [])

    useEffect(() => {
        loadBanks();
    }, [])


    const loadBanks = async () => {

        const resp = await topApi.get<BanksResponse>('/bank/getBanks');
        if (resp.status == 200) {
            setBanks([...resp.data.banks]);
            setTotalPage(1);
        }


    }

    const addBank = async (bank: Bank) => {
        try {
            bank.id = undefined;
            const resp = await topApi.post<BankResponse>('/bank/', { bank });
            setBanks([...banks, resp.data.bank]);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }


    const updateBank = async (bank: Bank) => {
        try {
            const resp = await topApi.put<Bank>(`/bank/${bank.id}`, { bank });

            setBanks(banks.map(prod => {
                return (prod.id === bank.id)
                    ? resp.data["bank"]
                    : prod;
            }));

            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }


    }

    const deleteBank = async (id: number) => {
        try {
            await topApi.delete<Bank>(`/bank/${id}`);
            setBanks((prevBanks) =>
                prevBanks.filter((bank) => bank.id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const loadCountries = async () => {

        const resp = await topApi.get<CountriesResponse>('/bank/getCountries');
        if (resp.status == 200) {
            setCountries([...resp.data.countries]);
            setTotalPage(1);
        }


    }

    return (
        <BanksContext.Provider value={{ banks, countries, totalPage, loadBanks, addBank, updateBank, deleteBank, loadCountries }}>
            {children}
        </BanksContext.Provider>
    );
}